module.exports = __webpack_public_path__ + "media/images/pic/saska/aska_hero_bg-9e2b02b622ea4dd85d6803a601f14290.png";